export const createEducation = ({ BeURL, education, setEducation, handleTopClear }) => {
    if (!BeURL || !education.length === 0) {
        alert("Please fill all required fields and check server URL")
    }

    fetch(`${BeURL}/candidate-education`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ education }),
    })
        .then((res) => res.json())
        .then((data) => {

            alert(data.message);

            if (data.success) {
                setEducation(prev => [...prev, education[0]])
                handleTopClear()
                window.location.reload()
            } else {
                alert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in create a new education", err);

        });

}

